import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Stack
} from '@mui/material'

import { CustomerEntry, OneTimeReminderInfoViaEnum } from '../../sdk'
import { dedupArray } from '../../utils/dedupArray/dedupArray'

export const SelectReminderVia = ({
  vias,
  setVias,
  customer
}: {
  vias: OneTimeReminderInfoViaEnum[]
  setVias: (vias: OneTimeReminderInfoViaEnum[]) => void
  customer: CustomerEntry | undefined
}) => {
  const handleChange = (checked: boolean, via: OneTimeReminderInfoViaEnum) => {
    if (checked) {
      setVias(
        dedupArray([...vias, via] as string[]) as OneTimeReminderInfoViaEnum[]
      )
    } else {
      setVias(vias.filter((v) => v !== via))
    }
  }
  return (
    <Stack>
      <FormControlLabel
        control={
          <Checkbox
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              handleChange(
                event.target.checked,
                OneTimeReminderInfoViaEnum.Email
              )
            }}
            checked={vias.includes(OneTimeReminderInfoViaEnum.Email)}
            disabled={!customer?.information?.email}
          />
        }
        label="By Email"
      />
      <FormHelperText>
        {!customer?.information?.email ? 'No email found for the customer' : ''}
      </FormHelperText>
      <FormControlLabel
        control={
          <Checkbox
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              handleChange(event.target.checked, OneTimeReminderInfoViaEnum.Sms)
            }}
            checked={vias.includes(OneTimeReminderInfoViaEnum.Sms)}
            disabled={!customer?.information?.phone}
          />
        }
        label="By Text"
      />
      <FormHelperText>
        {!customer?.information?.phone
          ? 'No phone number found for the customer'
          : ''}
      </FormHelperText>
    </Stack>
  )
}
